type FuWidgetsConfig = {
    fansUnited: {
        apiKey: string;
        clientId: string;
        environment: string;
        idSchema: string;
        lang: string;
    };
    firebase: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        appId: string;
    };
    themeOptions?: any;
    language: string;
    showAnswerExplanations: boolean;
    imagePosition: string;
    layoutTemplate: string;
};

const fuWidgetsConfig: FuWidgetsConfig = {
    fansUnited: {
        apiKey: process.env.NEXT_PUBLIC_FU_API_KEY!,
        clientId: process.env.NEXT_PUBLIC_FU_CLIENT_ID!,
        environment: process.env.NEXT_PUBLIC_FU_ENVIRONMENT!,
        idSchema: process.env.NEXT_PUBLIC_FU_ID_SCHEMA!,
        lang: process.env.NEXT_PUBLIC_FU_LANG!,
    },
    firebase: {
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
        authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
        appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID!,
    },
    language: process.env.NEXT_PUBLIC_FU_LANG!,
    showAnswerExplanations: true,
    imagePosition: 'left',
    layoutTemplate: 'SPLIT',
    themeOptions: {
        imageBackgroundGradient: {
            light: {
                standard: 'rgba(255, 255, 255, 0)',
                split: 'rgba(255, 255, 255, 0)',
                overlay: 'rgba(255, 255, 255, 0)',
            },
            dark: {
                standard: 'rgba(255, 255, 255, 0)',
                split: 'rgba(255, 255, 255, 0)',
                overlay: 'rgba(255, 255, 255, 0)',
            },
        },
    },
};

export default fuWidgetsConfig;
export type { FuWidgetsConfig };
